import { Base } from './_base.model';

export class EmailTemplate extends Base {
  id: string;
  name: string;
  sender_name: string;
  cc: string;
  is_default: boolean;
  subject: string;
  body: string;
  recipient_specific: boolean;
  bureau_id: string;
  is_blast: boolean;
  target_host: boolean;
  target_host_manager: boolean;
  target_speaker: boolean;
  target_attendee: boolean;
  target_planner: boolean;
  attachments: EmailTemplateAttachment[];
}

export class EmailTemplateAttachment {
  id: number;
  email_template_id: string;
  download_form_id: number | null;
  file: string | null;
  filename: string;
  extention: string;
  mimetype: string;
  rank: number;
  download_form?: any;
}
